import React from 'react';
import { getVintageLabel } from '/src/components/ICESections/Shared/helpers';
import Highlights from '/src/components/Reusable/Highlights/Highlights';

const FundsRaisedSummaryCards = ({ stats = {} }) => {
    const {
        totalFunds,
        vintageRange,
        totalTargetFundSize,
        totalCapitalRaised,
        totalCapitalRaisedHasProxy,
        capitalDeployed,
        pctDeployed,
        estDryPowder,
    } = stats;

    const items = [
        { key: 'totalFunds', label: 'Total Funds', displayValue: totalFunds ?? 'N/A', meta: getVintageLabel(vintageRange) },
        { key: 'totalTargetFundSize', label: 'Total Fund Raised', displayValue: totalTargetFundSize || 'N/A', meta: totalCapitalRaised ? `${totalCapitalRaised} committed` : 'Aggregate funds raised' },
        { key: 'capitalDeployed', label: 'Est. Capital Deployed', displayValue: capitalDeployed || 'N/A', meta: 'Across all funds' },
        { key: 'pctDeployed', label: 'Est. % Capital Deployed', displayValue: pctDeployed != null ? `${pctDeployed}%` : 'N/A', meta: 'Of total raised', progress: pctDeployed },
        { key: 'estDryPowder', label: 'Est. Dry Powder', displayValue: estDryPowder || 'N/A', meta: 'Capital available to deploy' },
    ];

    return <Highlights items={items} />;
}

export default FundsRaisedSummaryCards;
